export interface DocFile {
  label: string;
  url: string;
}

export interface DocItem {
  id: string;
  title: string;
  titleRu?: string;
  titleKk?: string;
  titleEn?: string;
  files: DocFile[];
}

export const documentsData: DocItem[] = [
  {
    id: 'doc-1',
    title: 'Устав Общественного объединения «Национальная Федерация по военно-прикладным видам спорта»',
    titleRu: 'Устав Общественного объединения «Национальная Федерация по военно-прикладным видам спорта»',
    titleKk: '«Әскери-қолданбалы спорт түрлері жөніндегі Ұлттық Федерациясы» Қоғамдық бірлестігінің Жарғысы',
    titleEn: 'Charter of the Public Association "National Federation of Military Applied Sports"',
    files: [
      { label: 'Устав (Казахский и русский)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/Устав-Фед-рус-каз-.pdf' },
    ],
  },
  {
    id: 'doc-2',
    title: 'Порядок вступления в члены Федерация и Положение о членских взносах',
    titleRu: 'Порядок вступления в члены Федерация и Положение о членских взносах',
    titleKk: 'Федерация мүшелігіне кіру тәртібі және мүшелік жарналар туралы Ереже',
    titleEn: 'Procedure for Membership Admission and Regulations on Membership Dues',
    files: [
      { label: 'ЕРЕЖЕЛЕРІ (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/10.04.22-Каз-Положение-о-членских-вступительных-и-целевых-взносах-Федерации.pdf' },
      { label: 'Қоғамдық Бірлестігінің мүшелігіне кіру (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/10.04.22-Каз-Порядок-вступления-в-члены-Федерации-и-прекращения-членства.pdf' },
      { label: 'ПОЛОЖЕНИЕ (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/10.04.22-Рус-Положение-о-членских-вступительных-и-целевых-взносах-Федерации.pdf' },
      { label: 'Порядок вступления (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/10.04.22-Рус-Порядок-вступления-в-члены-Федерации-и-прекращения-членства.pdf' },
    ],
  },
  {
    id: 'doc-3',
    title: 'РЕШЕНИЕ Общего собрания № 007 от 10.04.2022 «Об утверждении Порядка вступления в члены»',
    titleRu: 'РЕШЕНИЕ Общего собрания № 007 от 10.04.2022 «Об утверждении Порядка вступления в члены»',
    titleKk: 'Жалпы жиналыс ШЕШІМІ № 007 (10.04.2022 ж.) «Федерация мүшелігіне кіру тәртібін бекіту туралы»',
    titleEn: 'General Meeting DECISION No. 007 dated 10.04.2022 "On Approval of Membership Admission Procedure"',
    files: [
      { label: 'Шешімі 007 (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/каз-Решение-007-от-10.04.22г-Об-утверждении-Порядка-вступления-в-члены-Федерации-1.pdf' },
      { label: 'Решение 007 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/рус-Решение-007-от-10.04.22г-Об-утверждении-Порядка-вступления-в-члены-Федерации.pdf' },
    ],
  },
  {
    id: 'doc-4',
    title: 'РЕШЕНИЕ Общего собрания № 008 от 10.04.2022 «Об утверждении Положения о членских и вступительных взносах»',
    titleRu: 'РЕШЕНИЕ Общего собрания № 008 от 10.04.2022 «Об утверждении Положения о членских и вступительных взносах»',
    titleKk: 'Жалпы жиналыс ШЕШІМІ № 008 (10.04.2022 ж.) «Мүшелік және кіру жарналары туралы ережені бекіту туралы»',
    titleEn: 'General Meeting DECISION No. 008 dated 10.04.2022 "On Approval of Regulations on Entrance and Membership Fees"',
    files: [
      { label: 'Шешімі 008 (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/каз-Решение-008-от-10.04.22г-Об-утверждении-Положения-о-членских-вступительных-взносов-Федерации.pdf' },
      { label: 'Решение 008 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/рус-Решение-008-от-10.04.22г-Об-утверждении-Положения-о-членских-вступительных-взносов-Федерации.pdf' },
    ],
  },
  {
    id: 'doc-5',
    title: 'РЕШЕНИЕ Совета Правления № 003 от 20.12.2023 «Об утверждении обязательных членских взносов»',
    titleRu: 'РЕШЕНИЕ Совета Правления № 003 от 20.12.2023 «Об утверждении обязательных членских взносов»',
    titleKk: 'Басқарма кеңесінің ШЕШІМІ № 003 (20.12.2023 ж.) «Міндетті мүшелік жарналарды бекіту туралы»',
    titleEn: 'Board of Directors DECISION No. 003 dated 20.12.2023 "On Approval of Mandatory Membership Dues"',
    files: [
      { label: 'Шешімі 003 (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/20.12.23-Каз-Решение-003-Совета-Правления-об-утверждении-обязательных-членских-взносов.pdf' },
      { label: 'Решение 003 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/20.12.23-Рус-Решение-003-Совета-Правления-об-утверждении-обязательных-членских-взносов.pdf' },
    ],
  },
  {
    id: 'doc-6',
    title: 'РЕШЕНИЕ Совета Правления № 004 от 20.12.2023 «Об утверждении вступительных взносов»',
    titleRu: 'РЕШЕНИЕ Совета Правления № 004 от 20.12.2023 «Об утверждении вступительных взносов»',
    titleKk: 'Басқарма кеңесінің ШЕШІМІ № 004 (20.12.2023 ж.) «Кіру жарналарын бекіту туралы»',
    titleEn: 'Board of Directors DECISION No. 004 dated 20.12.2023 "On Approval of Entrance Dues"',
    files: [
      { label: 'Шешімі 004 (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/20.12.23-Каз-Решение-004-Совета-Правления-об-утверждении-вступительных-взносов.pdf' },
      { label: 'Решение 004 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/20.12.23-Каз-Решение-004-Совета-Правления-об-утверждении-вступительных-взносов.pdf' },
    ],
  },
  {
    id: 'doc-7',
    title: 'Правила по военно-прикладным видам спорта Международного Союза ВПС',
    titleRu: 'Правила по военно-прикладным видам спорта Международного Союза ВПС',
    titleKk: 'Халықаралық ӘҚС Одағының әскери-қолданбалы спорт түрлері бойынша ережелері',
    titleEn: 'Rules on Military Applied Sports of the International Union of Military Applied Sports',
    files: [
      { label: 'Правила на казахском языке (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/KAZ-Правила-Воен.прикл.вид.спорта-1-2.pdf' },
      { label: 'Правила на русском языке (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/RUS-Правила-Воен.прикл.вид.спорта-Союза-1-1-2.pdf' },
    ],
  },
  {
    id: 'doc-8',
    title: 'Руководящий состав Общественного объединения «Национальная Федерация по военно-прикладным видам спорта»',
    titleRu: 'Руководящий состав Общественного объединения «Национальная Федерация по военно-прикладным видам спорта»',
    titleKk: '«Әскери-қолданбалы спорт түрлері жөніндегі Ұлттық Федерациясы» ҚБ басқару органдары',
    titleEn: 'Executive Leadership of the Public Association "National Federation of Military Applied Sports"',
    files: [
      { label: 'Басқару органдары (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/Каз-Органы-управления-Федерациии.pdf' },
      { label: 'Органы управления (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2024/09/Рус-Органы-управления-Федерациии.pdf' },
    ],
  },
  {
    id: 'doc-9',
    title: 'Сведения о наличии филиалов и представительств из ИС Министерства Юстиции РК',
    titleRu: 'Сведения о наличии филиалов и представительств из ИС Министерства Юстиции РК',
    titleKk: 'ҚР Әділет министрлігінің ақпараттық жүйесінен филиалдар мен өкілдіктер туралы мәліметтер',
    titleEn: 'Information on Branches and Representative Offices from the Ministry of Justice of RK',
    files: [
      { label: 'Сведения о филиалах и представительствах', url: 'https://militarysport.kz/wp-content/uploads/2024/09/1-Сведения-о-филиалах-НФ-по-ВПС-1.pdf' },
    ],
  },
];

export const patriotDocumentsData: DocItem[] = [
  {
    id: 'pat-1',
    title: 'РЕШЕНИЕ Совета Правления № 005 от 09.01.2025 «Об утверждении размера обязательных членских взносов на 2025 год»',
    titleRu: 'РЕШЕНИЕ Совета Правления № 005 от 09.01.2025 «Об утверждении размера обязательных членских взносов на 2025 год»',
    titleKk: 'Басқарма кеңесінің ШЕШІМІ № 005 (09.01.2025 ж.) «2025 жылға арналған міндетті мүшелік жарналар мөлшерін бекіту туралы»',
    titleEn: 'Board DECISION No. 005 dated 09.01.2025 "On Approval of Mandatory Membership Dues for 2025"',
    files: [
      { label: 'Шешім 005 (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/09.01.25-ф-Каз-Решение-005-Совета-Правления-об-утверждении-обязательных-членских-взносов.pdf' },
      { label: 'Решение 005 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/09.01.25-ф-Рус-Решение-005-Совета-Правления-об-утверждении-обязательных-членских-взносов.pdf' },
    ],
  },
  {
    id: 'pat-2',
    title: 'Приложение №12 к Решению № 005 Совета Правления от 09.01.2025г.',
    titleRu: 'Приложение №12 к Решению № 005 Совета Правления от 09.01.2025г.',
    titleKk: 'Басқарма кеңесінің 09.01.2025 ж. № 005 шешіміне №12 Қосымша',
    titleEn: 'Appendix No. 12 to Board Decision No. 005 dated 09.01.2025',
    files: [
      { label: '№12 Қосымша (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/Каз-Приложение-№12-к-протоколу-заседания-совета-правления-Федерации-от-09.01.25г.pdf' },
      { label: 'Приложение №12 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/Рус-Приложение-№12-к-протоколу-заседания-совета-правления-Федерации-от-09.01.25г.pdf' },
    ],
  },
  {
    id: 'pat-3',
    title: 'РЕШЕНИЕ Совета Правления № 006 от 09.01.2025 «Об утверждении размера вступительных взносов кандидатов на 2025 год»',
    titleRu: 'РЕШЕНИЕ Совета Правления № 006 от 09.01.2025 «Об утверждении размера вступительных взносов кандидатов на 2025 год»',
    titleKk: 'Басқарма кеңесінің ШЕШІМІ № 006 (09.01.2025 ж.) «2025 жылға арналған мүшелікке кіру жарналарының мөлшерін бекіту туралы»',
    titleEn: 'Board DECISION No. 006 dated 09.01.2025 "On Approval of Candidate Entrance Dues for 2025"',
    files: [
      { label: 'Решение 006 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/09.01.25-ф-Рус-Решение-006-Совета-Правления-об-утверждении-вступительных-взносов.pdf' },
      { label: 'Шешім 006 (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/09.01.25-ф-Каз-Решение-006-Совета-Правления-об-утверждении-вступительных-взносов.pdf' },
    ],
  },
  {
    id: 'pat-4',
    title: 'Приложение №13 к Решению № 006 Совета Правления от 09.01.2025г.',
    titleRu: 'Приложение №13 к Решению № 006 Совета Правления от 09.01.2025г.',
    titleKk: 'Басқарма кеңесінің 09.01.2025 ж. № 006 шешіміне №13 Қосымша',
    titleEn: 'Appendix No. 13 to Board Decision No. 006 dated 09.01.2025',
    files: [
      { label: '№13 Қосымша (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/Каз-Приложение-№13-к-протоколу-заседания-совета-правления-Федерации-от-09.01.25.pdf' },
      { label: 'Приложение №13 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/Рус-Приложение-№13-к-протоколу-заседания-совета-правления-Федерации-от-09.01.25г.pdf' },
    ],
  },
  {
    id: 'pat-5',
    title: 'РЕШЕНИЕ Общего собрания № 010 от 10.02.2025 «Об утверждении Проекта Концепции до 2030 года»',
    titleRu: 'РЕШЕНИЕ Общего собрания № 010 от 10.02.2025 «Об утверждении Проекта Концепции до 2030 года»',
    titleKk: 'Жалпы жиналыс ШЕШІМІ № 010 (10.02.2025 ж.) «Федерацияның 2030 жылға дейінгі Тұжырымдамасының жобасын бекіту туралы»',
    titleEn: 'General Meeting DECISION No. 010 dated 10.02.2025 "On Approval of the Concept Project through 2030"',
    files: [
      { label: 'Шешім 010 (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/10.02.25-ф-Каз-Решение-010-об-утверждении-Концепции-Федерации-до-2030-года.pdf' },
      { label: 'Решение 010 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/10.02.25-ф-Рус-Решение-010-об-утверждении-Концепции-Федерации-до-2030-года.pdf' },
    ],
  },
  {
    id: 'pat-6',
    title: 'Концепция военно-патриотического воспитания молодежи и развития военно-прикладных видов спорта до 2030 года',
    titleRu: 'Концепция военно-патриотического воспитания молодежи и развития военно-прикладных видов спорта до 2030 года',
    titleKk: 'Жастарға әскери-патриоттық тәрбие беру және әскери-қолданбалы спорт түрлерін 2030 жылға дейін дамыту Тұжырымдамасы',
    titleEn: 'Concept for Youth Patriotic Education and Development of Military Applied Sports through 2030',
    files: [
      { label: 'Тұжырымдама (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/27.07.25-Каз-Концепция-Федерации-по-ВПС.pdf' },
      { label: 'Концепция (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/27.07.25-Рус-Концепция-Федерации-по-ВПС.pdf' },
    ],
  },
  {
    id: 'pat-7',
    title: 'РЕШЕНИЕ Общего собрания № 011 от 10.02.2025 «Об утверждении Положения о ВПК «Патриот»»',
    titleRu: 'РЕШЕНИЕ Общего собрания № 011 от 10.02.2025 «Об утверждении Положения о ВПК «Патриот»»',
    titleKk: 'Жалпы жиналыс ШЕШІМІ № 011 (10.02.2025 ж.) «Патриот» ӘПК Ережесінің жобасын бекіту туралы»',
    titleEn: 'General Meeting DECISION No. 011 dated 10.02.2025 "On Approval of Regulations for "Patriot" Military-Patriotic Club"',
    files: [
      { label: 'Шешім 011 (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/10.02.25-ф-Каз-Решение-011-об-утверждении-Положения-ВПК-Патриот-Федерации.pdf' },
      { label: 'Решение 011 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/10.02.25-ф-Рус-Решение-011-об-утверждении-Положения-ВПК-Патриот-Федерации.pdf' },
    ],
  },
  {
    id: 'pat-8',
    title: 'Положение о военно-патриотическом клубе «Патриот»',
    titleRu: 'Положение о военно-патриотическом клубе «Патриот»',
    titleKk: '«Патриот» әскери-патриоттық клубы туралы Ереже',
    titleEn: 'Regulations on the "Patriot" Military-Patriotic Club',
    files: [
      { label: 'Ереже (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/1-05.06.25-Каз-Положение-о-военно-патриотическом-клубе-НФ-по-ВПС.pdf' },
      { label: 'Положение (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/1-05.06.25-Рус-Положение-о-военно-патриотическом-клубе-НФ-по-ВПС.pdf' },
    ],
  },
  {
    id: 'pat-9',
    title: 'РЕШЕНИЕ Общего собрания № 012 от 10.02.2025 «Об утверждении Проектов Устава ВПК «Патриот»»',
    titleRu: 'РЕШЕНИЕ Общего собрания № 012 от 10.02.2025 «Об утверждении Проектов Устава ВПК «Патриот»»',
    titleKk: 'Жалпы жиналыс ШЕШІМІ № 012 (10.02.2025 ж.) «Патриот» ӘПК Жарғысының жобаларын бекіту туралы»',
    titleEn: 'General Meeting DECISION No. 012 dated 10.02.2025 "On Approval of Draft Charters for "Patriot" Club"',
    files: [
      { label: 'Шешім 012 (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/10.02.25-ф-Каз-Решение-012-об-утверждении-Положения-ВПК-Патриот.pdf' },
      { label: 'Решение 012 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/10.02.25-ф-Рус-Решение-012-об-утверждении-Положения-ВПК-Патриот.pdf' },
    ],
  },
  {
    id: 'pat-10',
    title: 'Проект-1 Устава ВПК «Патриот»',
    titleRu: 'Проект-1 Устава ВПК «Патриот»',
    titleKk: '«Патриот» ӘПК Жарғысының 1-Жобасы',
    titleEn: 'Draft-1 Charter of the "Patriot" Club',
    files: [
      { label: '1-Жоба (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/07.06.25-Каз-Проект-1-Устава-ВПК-Патриот-НФ-по-ВПС.pdf' },
      { label: 'Проект-1 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/Рус-Проект-1-Устава-ВПК-Патриот-НФ-по-ВПС.pdf' },
    ],
  },
  {
    id: 'pat-11',
    title: 'Проект-2 Устава ВПК «Патриот»',
    titleRu: 'Проект-2 Устава ВПК «Патриот»',
    titleKk: '«Патриот» ӘПК Жарғысының 2-Жобасы',
    titleEn: 'Draft-2 Charter of the "Patriot" Club',
    files: [
      { label: '2-Жоба (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/07.06.25-Каз-Проект-2-Устава-ВПК-НФ-по-ВПС.pdf' },
      { label: 'Проект-2 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/07.06.25-Рус-Проект-2-Устава-ВПК-НФ-по-ВПС.pdf' },
    ],
  },
  {
    id: 'pat-12',
    title: 'РЕШЕНИЕ Общего собрания № 013 от 10.02.2025 «Об утверждении Проекта дополнительной образовательной программы ВПК «Патриот»»',
    titleRu: 'РЕШЕНИЕ Общего собрания № 013 от 10.02.2025 «Об утверждении Проекта дополнительной образовательной программы ВПК «Патриот»»',
    titleKk: 'Жалпы жиналыс ШЕШІМІ № 013 (10.02.2025 ж.) «Патриот» ӘПК қосымша білім беру бағдарламасының жобасын бекіту туралы»',
    titleEn: 'General Meeting DECISION No. 013 dated 10.02.2025 "On Approval of Additional Educational Program Project"',
    files: [
      { label: 'Шешім 013 (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/10.02.25-ф-Каз-Решение-013-об-утверждении-доп.прогр.образования-ВПК-Патриот.pdf' },
      { label: 'Решение 013 (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/10.02.25-ф-Рус-Решение-013-об-утверждении-доп.прогр.образования-ВПК-Патриот.pdf' },
    ],
  },
  {
    id: 'pat-13',
    title: 'ДОПОЛНИТЕЛЬНАЯ ОБРАЗОВАТЕЛЬНАЯ ПРОГРАММА ВПК «Патриот»',
    titleRu: 'ДОПОЛНИТЕЛЬНАЯ ОБРАЗОВАТЕЛЬНАЯ ПРОГРАММА ВПК «Патриот»',
    titleKk: '«Патриот» әскери-патриоттық клубының ҚОСЫМША БІЛІМ БЕРУ БАҒДАРЛАМАСЫ',
    titleEn: 'ADDITIONAL EDUCATIONAL PROGRAM of the "Patriot" Military-Patriotic Club',
    files: [
      { label: 'Бағдарлама (Қаз)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/08.06.25-каз-Дополнительная-образов.-прогр.-для-специалистов-ВПК-Патриот.pdf' },
      { label: 'Программа (Рус)', url: 'https://militarysport.kz/wp-content/uploads/2025/10/08.06.25-рус-Дополнительная-образов.-прогр.-для-специалистов-ВПК-Патриот.pdf' },
    ],
  },
];